import Player from '@meteogroup/player-core';
import { PlayerOptions } from '@meteogroup/player-core/Player';

// Wrapper around MGs player, that handles updating current time
// When the player is not playing (or paused), it will still update the time in the requested time intervals to Date.now()
// Default is to update to date.Now() once a minute
export class TimeController
{
    player: Player;

    constructor(playerOptions: PlayerOptions, interval: number = 60*1000)
    {
        this.player = new Player(playerOptions);
        this.player.currentTime = Date.now();
    }
}
